import axios from "../plugins/parseAxios";
export class InvoiceLogAPI {
  static getInvoiceLogs(invoiceId) {
    return axios.post("functions/getInvoiceLogs", { invoiceId });
  }
}
